import {API} from "aws-amplify";
import {GRAPHQL_AUTH_MODE, GraphQLQuery} from "@aws-amplify/api";
import {GetManualHtmlQuery, GetManualHtmlQueryVariables} from "../../API";
import * as queries from "../../graphql/queries";
import aws_config from "../../modified_aws-export";


export const handleGetManualHtml = async (manualId: String): Promise<any> => {
    try {
        const result = await API.graphql<GraphQLQuery<GetManualHtmlQuery>>({
            query: queries.getManualHtml,
            variables: {
                input: {
                    manualId: manualId,
                    company: aws_config.aws_ssm_param_rmi_company_name,
                    password: aws_config.aws_ssm_param_rmi_secret_name,
                    username: aws_config.aws_ssm_param_rmi_user_name,
                    typeId: aws_config.aws_ssm_param_rmi_type_id,
                },
            } as GetManualHtmlQueryVariables,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
        });

        if (result.data) {
            const data = result.data.getManualHtml;
            if (data) {
                const parsedData = JSON.parse(data);
                return JSON.parse(parsedData.body);
            }
        }
    } catch (error) {
        console.error(error);
    }
};
